var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pictureContainer",staticClass:"picture",class:[_vm.imageContainClassName, _vm.coverModeClassName]},[(_vm.sourceToShow)?_c('img',{attrs:{"src":_vm.sourceToShow.src}}):(_vm.isLoading && _vm.withSkeleton)?_c('div',{staticClass:"picture__skeleton-box"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }